import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LenisProvider, useLenis } from "@/components/LenisProvider";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#090909] text-[#F5F5F5] flex flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-display text-3xl">Something spilled.</p>
          <p className="text-[#A3A3A3] text-sm">We hit an unexpected error.</p>
          <button
            data-testid="error-reload-button"
            onClick={() => window.location.reload()}
            className="mt-2 bg-[#D98B48] text-[#090909] px-6 py-3 rounded-sm text-sm font-medium hover:bg-[#F0A562] transition-colors"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" />
        </LenisProvider>
      </BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
    </ErrorBoundary>
  );
}

export default App;
